import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useDarkMode from "../../hooks/useDarkMode";
import { login } from "../../redux/auth/actions";
import { useAppDispatch } from "../../hooks/hooks";
import { useSelector } from "react-redux";
import { userProfile } from "../../redux/userProfile/action";
import { useForm } from "react-hook-form";
import storePersist from "../../redux/storePersist";
import _ from "lodash";
import { getAccountTypeChannalName } from "../../common/services/common.service";
import { selectChannelListItems } from "../../redux/channel/selector";
import useWindowDimensions from "../../hooks/useWindowsDimensions";
import PageLoader from "../../components/PageLoader";
import { toast } from "react-toastify";
import { RotatingLines } from "react-loader-spinner";
import EmailInput from "../../common/components/form/EmailInput.Component";
import PasswordInput from "../../common/components/form/PasswordInput.Component";
import { settings } from "../../redux/settings/actions";

export default function ManagementLogin() {
	const navigate = useNavigate()
	const dispatch = useAppDispatch()
	const { height, width } = useWindowDimensions();
	const { register, handleSubmit, clearErrors, formState: { errors }, setValue } = useForm();
	const [loginValues, setLoginValues] = useState<any>()
	const [colorTheme, setTheme] = useDarkMode();
	const [steps, setSteps] = useState({ Email: '', Password: '' })
	const [darkSide, setDarkSide] = useState(
		colorTheme === "light" ? true : false
	);
	const [isLoading, setIsLoading] = useState<boolean>(false)
	const [showPassword, setShowPassword] = useState(false);

	const handleClickShowPassword = () => {
		setShowPassword(!showPassword);
	};
	const toggleDarkMode = (checked: any) => {
		setTheme(colorTheme);
		setDarkSide(checked);
	};

	const handleChange: any = (event: any, field: string) => {
		setLoginValues({ ...loginValues, [field]: event })
	}
	const handleSteps = (e: any, key: any) => {
		setSteps({ ...steps, [key]: e.target.value })
	}
	const gotoHome = (role: any) => {
		switch (role?.toLocaleLowerCase()) {
			case 'businessowner':
				navigate('/management/home')
				break;
			default:
				navigate('/auth/login/management')
		}
	}

	const handleForgotPassword = (e: any) => {
		e.preventDefault();
		storePersist.set('reset-pwd', 'management')
		navigate('/auth/login/forgot-password')
	}

	const onFinish = async () => {
		try {
			await setIsLoading(true)
			await dispatch(login({
				loginData: {
					"Records": [
						{
							"Context": {
								"Domain": "ERP",
								"Platform": "Management",
								"Application": "Management"
							},
							"Message": {
								"Username": steps?.Email,
								"Password": steps?.Password,
								"AccountType": "Internal",
								"LoginWithOtp": false,
								"Otp": "",
								"IsGoogleAuthenticated": false,
								"AuthenticatedUserId": "",
								"ClientIPAddress": "",
								"OrganizationUnitId": 0
							}
						}
					]

				}
			}))

			const resp: any = await dispatch(userProfile.read({ url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/iam/user-service/user-profile/me`, entity: 'userProfile' }))
			let selectedRole = ''
			const targetRoles = ['businessowner']; // Roles to match
			resp.find((element: any) =>
				element?.Message?.Roles.find((role: any) => {
					if (targetRoles.includes(role?.Name?.toLowerCase())) {
						selectedRole = role.Name.toLowerCase();
						return true;
					}
					return false;
				})
			);
			await gotoHome(selectedRole);
			await setIsLoading(false)
		} catch (e: any) {
			// toast.error('There was an error in login. Please try again...')
			console.error('Login failed:', e?.Error?.Message);
			await setIsLoading(false)
		}
	};

	useEffect(() => {
		window.scrollTo({ top: 0, behavior: "smooth" })
		clearErrors('Email')
		clearErrors('Password')
	}, [])

	return (<>

		<form onSubmit={handleSubmit(onFinish)} >
			{(width && width < 724) ? <>
				<div className="w-screen h-screen bg-white px-6 flex items-center justify-center sm:hidden">
					<div className="w-full max-w-sm bg-white shadow-lg rounded-lg p-6">
						<h2 className="text-2xl font-semibold text-center">Management Log In</h2>
						<div className="flex justify-center my-2">
							<svg width="172" height="29" viewBox="0 0 172 29" fill="none" xmlns="http://www.w3.org/2000/svg" className="mx-auto mb-5">
								<path d="M1 5.08742C17.6667 19.0972 30.5 31.1305 62.5 27.2693C110.617 21.4634 150 -10.09 171 5.08727" stroke="#FFBB38"></path>
							</svg>
						</div>
						<div className="space-y-5">
							<EmailInput
								label="Email Address"
								name="Email"
								isRequired={true}
								register={register}
								errors={errors}
								setValue={setValue}
								handleSteps={(e) => handleSteps(e, 'Email')}
							/>

							<PasswordInput
								label="Password"
								name="Password"
								isRequired={true}
								// minLength={3}
								// maxLength={10}
								register={register}
								errors={errors}
								setValue={setValue}
								handleSteps={(e) => handleSteps(e, 'Password')}
							/>
						</div>

						<div className="flex justify-between items-center my-4">
							<label className="flex items-center cursor-pointer">
								<input type="checkbox" className="form-checkbox" />
								<span className="ml-2 text-md text-black">Remember me</span>
							</label>
							<a href="#" onClick={handleForgotPassword} className="text-yellow-500 text-md">Forgot password?</a>
						</div>

						<button
							type="submit"
							disabled={isLoading}
							className={`w-full h-11 flex items-center justify-center text-white rounded-lg text-lg font-semibold ${isLoading ? 'bg-opacity-70 bg-primary' : 'bg-primary'}`}
						>
							Login
							<div className={` ${isLoading ? 'visible pl-2' : 'invisible'}`}>
								<RotatingLines
									visible={true}
									width={'20'}
									strokeColor="#fff"
									strokeWidth="6"
									animationDuration="0.75"
									ariaLabel="rotating-lines-loading"
								/>
							</div>
						</button>




					</div>
				</div>
			</> :
				<div className="flex max-h-screen bg-[#F8F8F8]">
					<div className="container  mx-auto px-4 flex flex-col lg:flex-row items-center justify-between">
						{/* Left Side - Form Section */}
						<div className="w-full lg:w-1/2  flex justify-center">
							<div className="w-full  bg-white p-6 h-[500px]">
								<div className="text-center">
									<h2 className="text-3xl font-bold">Log In</h2>
									<div className="flex justify-center mt-2">
										<svg width="120" height="20" viewBox="0 0 172 29" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M1 5.08742C17.6667 19.0972 30.5 31.1305 62.5 27.2693C110.617 21.4634 150 -10.09 171 5.08727" stroke="#FFBB38"></path>
										</svg>
									</div>
								</div>

								{/* Password and Email Input */}
								<div className="space-y-5">
									<EmailInput
										label="Email Address"
										name="Email"
										isRequired={true}
										register={register}
										errors={errors}
										setValue={setValue}
										handleSteps={(e) => handleSteps(e, 'Email')}
									/>

									<PasswordInput
										label="Password"
										name="Password"
										isRequired={true}
										register={register}
										errors={errors}
										setValue={setValue}
										handleSteps={(e) => handleSteps(e, 'Password')}
									/>
								</div>


								{/* Remember Me & Forgot Password */}
								<div className="flex justify-between items-center text-sm mt-4">
									<label className="flex items-center space-x-2">
										<input type="checkbox" className="form-checkbox" />
										<span>Remember me</span>
									</label>
									<a href="#" onClick={(e) => handleForgotPassword(e)} className="text-yellow-500">
										Forgot password?
									</a>
								</div>

								{/* Submit Button */}
								<div className="mt-6">

									<button
										type="submit"
										disabled={isLoading}
										className={`${isLoading ? 'bg-primary bg-opacity-70' : 'bg-primary'
											} flex-row flex items-center justify-center text-light rounded font-semibold text-xl p-4 w-full h-11`}
									>
										Login
										<div className={` ${isLoading ? 'visible pl-2' : 'invisible'}`}>
											<RotatingLines
												visible={true}
												width={'20'}
												strokeColor="#fff"
												strokeWidth="6"
												animationDuration="0.75"
												ariaLabel="rotating-lines-loading"
											/>
										</div>
									</button>

								</div>

								{/* Google Sign-in */}
								{/* <div className="flex items-center justify-center space-x-2 mt-6 bg-gray-100 p-3 rounded">
							<img src={require('./../../assets/img/google.jpeg')} className="h-5 w-5" />
							<button className="text-sm text-gray-600" onClick={() => startGoogleAuthentication()}>
								Sign In with Google
							</button>
						</div> */}

								{/* Sign Up Link */}
								{/* <div className="text-center text-sm text-gray-600 mt-4">
								Don't have an account?
								<span onClick={() => handleRegistration()} className="text-black font-medium cursor-pointer"> Sign Up Free</span>
							</div> */}
							</div>
						</div>

						{/* Right Side */}
						<div className="hidden lg:flex w-1/2 justify-center">
							<img src={require('../../assets/img/logisticsLogin.png')} className="max-w-lg" alt="Login Illustration" />
						</div>
					</div>
				</div>}
		</form >

	</>

	);
}
